import React, {useContext, useEffect, useState, useCallback} from 'react';
import { useNavigate } from "react-router-dom";
import { InputContext } from '../../contexts/InputContext';
import resourcesServices from '../../services/resourcesServices';
import notificacionesServices from '../../services/notificacionesServices';
import SelectControl from '../customizedInputs/SelectControl';
import TextControl from '../customizedInputs/TextControl';
import { SimpleMdeReact } from "react-simplemde-editor";
import "easymde/dist/easymde.min.css";
import { errorMessage } from '../../errorHandler';
import AsyncSelect from 'react-select/async';

const NotificacionFormPartial = ({id, updatedNotificacion, cerrarModal, esModal=false}) => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false)
  const [notificacion, setNotificacion] = useState({});
  const [esNuevo, setEsNuevo] = useState(true);
  const [mensaje, setMensaje] = useState("");
  const [asunto, setAsunto] = useState("");
  const [saving, setSaving] = useState(false);
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [selectedUser, setSelectedUser] = useState({value: '', label: ''});
  const [tipo, setTipo] = useState(null);
  const [tipos, setTipos] = useState([]);

  useEffect(() => {
    setEsNuevo( id === undefined )
    if(id){
      fetchNotificacion(id)
    } else {
      nuevaNotificacion()
    }
  }, [id]);

  useEffect(() => {
    setNotificacion({...notificacion,
        'mensaje': mensaje
    })

  }, [mensaje]);

  useEffect(() => {

    setAsunto(`${notificacion.expediente || ''} | ${notificacion.cedula || ''}`)

  }, [notificacion.expediente, notificacion.cedula]);

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( authInformation.autenticado === true){
      setRenderHTML(true)
      if(authInformation.rol === "Supervisor" || authInformation.es_supervisor){
        primerosUsuarios()
      }
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);

  const primerosUsuarios = async() => {
    try {
      const results = await resourcesServices.obtenerResources('usuarios', '', {"query": ""});

      const usuarioOptions = results.data.map((usuario) => ({
        value: usuario.id,
        label: `${usuario.nombre} ${usuario.apellido}`,
      }));

      setDefaultOptions(usuarioOptions)

    } catch (error) {
      console.error('Error al buscar usuarios:', error);
    }
  }

  const fetchNotificacion = async (id) => {
    try {
      const data = await resourcesServices.obtenerResourcePorId('notificaciones', id);
      setSelectedUser(
        {
          value: data.usuario_notificado_id,
          label: `${data.usuario_notificado.nombre} ${data.usuario_notificado.apellido}`
        }
      )
      setNotificacion(data);
      setMensaje(data.mensaje)
    } catch (error) {
      errorMessage(error)
    }
  };

  const nuevaNotificacion = async (id) => {
    try {
      const data = await resourcesServices.nuevoResource('notificaciones');
      setNotificacion(data);
      const tipo_notificaciones = await resourcesServices.obtenerResourcePorId('notificaciones', 'obtenerTipos');
      setTipos(tipo_notificaciones)
      setMensaje("")
    } catch (error) {
      errorMessage(error)
    }
  };

  const guardarNotificacion = async (enviar=false) => {
    try {
      setSaving(true)
      const attributeName = 'notificacion'
      const copiaNotificacion = {...notificacion}

      
      if(enviar){
        copiaNotificacion.estado = 'para_enviar'
      }

      const formData =  new FormData();
      for(const [key, value] of Object.entries(copiaNotificacion)){
        if(value){
          if(key === "adjuntos"){
            for(let i = 0; i < value.length; i++){
              formData.append(`${attributeName}[${key}][]`, value[i], value[i].name)
            }
          } else {
            formData.append(`${attributeName}[${key}]`, value)
          }
        }
      }

      if(esNuevo){
        await notificacionesServices.crearNotificacion('notificaciones', formData);
      } else {
        await notificacionesServices.actualizarNotificacion('notificaciones', copiaNotificacion.id, formData);
      }

      setSaving(false)

      alert("Información actualizada")

      if( authInformation.rol === 'Obligado' ) {
        navigate(`/notificaciones`);
      } else {
        // Notificador, Admin, Supervisor
        navigate(`/notificaciones-notificador`);
      }

    } catch (error) {
      setSaving(false)
      errorMessage(error)
    }
  };

  const eliminarAdjunto = async (adjunto_id) => {
    try {
      if(window.confirm('Está seguro que quiere eliminar el archivo adjunto?')) {
        const data = await notificacionesServices.eliminarAdjuntoNotificacion('notificaciones', notificacion.id, adjunto_id);
        setNotificacion({...notificacion,
          archivos_adjuntos: data.archivos_adjuntos,
        })
      }
    } catch (error) {
      errorMessage(error)
    }
  };

  const quitarAdjunto = async (idx) => {
    try {
      const adjuntos = notificacion.adjuntos
      adjuntos.splice(idx, 1)
      setNotificacion((prev) => ({
        ...prev,
        adjuntos: adjuntos,
      }));

    } catch (error) {
      errorMessage(error)
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setNotificacion({...notificacion,
      [name]: value
    })
  }

  const handleInputTipo = (e) => {
    setTipo(e.target.value)

    setNotificacion({...notificacion,
      ['tipo']: e.target.value
    })
  }

  const onChangeMensaje = useCallback((value: string) => {
    setMensaje(value);
  }, []);

  const handleFileChange = (e) => {
    const { name, files } = e.target;

    setNotificacion((prev) => ({
      ...prev,
      adjuntos: [...(prev.adjuntos || []), files[0]],
    }));

  };

  const handleInputNombreUsuario = async (newValue) => {
    if(newValue !== null){
      setSelectedUser(newValue)
      setNotificacion({...notificacion,
        ['usuario_notificado_id']: newValue.value
      })
    }
  }

  const buscarUsuarios = async(inputValue) => {
    try {
      // if( inputValue.length < 3 ){
      //   return []
      // }

      const results = await resourcesServices.obtenerResources('usuarios', '', {query: inputValue});

      const usuarioOptions = results.data.map((usuario) => ({
        value: usuario.id,
        label: `${usuario.nombre} ${usuario.apellido}`,
      }));

      // return [];
      return usuarioOptions;
    } catch (error) {
      console.error('Error al buscar usuarios:', error);
      return {};
    }
  }

  // https://stackoverflow.com/questions/54218351/changing-height-of-react-select-component
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minWidth: '450px'
    }),
  };

  return (
    <div>
      {renderHTML && (
        <div className="card">
          <div className="card-body px-0 pb-2 ms-3 me-3">
            {
              esNuevo && tipo === null ? (
                <>
                Elija el tipo
                <SelectControl
                    value={tipo}
                    options={tipos}
                    name={'tipo'}
                    handleInput={handleInputTipo}
                    label={'Seleccione el tipo'}
                  />                
                </>
              ) : (
                <form>
                  {/* <pre>{JSON.stringify(notificacion, null, 2)}</pre> */}
                  <h3 className='mb-5'>Tipo de notificación: {tipo}</h3>
                  <label>Usuario a notificar</label>
                  <div className="mb-3 w-50">
  
                    <AsyncSelect
                        loadOptions={(e) => buscarUsuarios(e)}
                        placeholder="Buscar por nombre..."
                        onChange={(e) => handleInputNombreUsuario(e)}
                        value={selectedUser}
                        styles={customStyles}
                        options={defaultOptions}
                        defaultOptions
                        isClearable
                      />
  
                  </div>

                  {
                    notificacion.tipo === 'nota' || (esNuevo && tipo === 'nota') ? (
                      <>
                        <TextControl
                          value={notificacion.asunto}
                          name={'asunto'}
                          handleInput={handleInput}
                          />
                      </>
                    ) : (
                      <>
                        <p>
                          <label>Asunto: </label> {asunto}
                        </p>
                        <TextControl
                          value={notificacion.expediente}
                          name={'expediente'}
                          handleInput={handleInput}
                          />
        
                        <TextControl
                          value={notificacion.cedula}
                          name={'cedula'}
                          handleInput={handleInput}
                          label='Cédula'
                          />
                      </>
                    )
                  }

  
                  <label>Mensaje</label>
                  <SimpleMdeReact value={mensaje} onChange={onChangeMensaje} />
  
                  <div className="card mb-3">
                    <div className="card-body">
                      {/* <div className="mb-3">
                        <input placeholder="Adjunte los documentos" className="form-control" onChange={handleFileChange} name="adjuntos" type="file" id="adjuntos" multiple/>
                      </div> */}
                      <div className="mb-3">
                        <input placeholder="Adjunte un archivo" className="form-control" onChange={handleFileChange} name="archivo_adjunto" type="file" id="archivo_adjunto" />
                      </div>
                      
                    {
                        notificacion.adjuntos && notificacion.adjuntos.map((adjunto, index) => (
                          <li key={index} className='list-group-item'>
                            {adjunto.name}
                            <button type="button" onClick={() => quitarAdjunto(index)} className='btn btn-danger ms-3'>Quitar</button>
                          </li>
                        ))
                      }                      
                    </div>
                  </div>
  
                  <div className='card mb-3'>
                    <ul className='list-group list-group-flush'>
                    {
                      notificacion.archivos_adjuntos && notificacion.archivos_adjuntos.map((adjunto, index) => (
                        <li key={index} className='list-group-item'>
                          {adjunto.nombre}
                          <a href={adjunto.url} target='_blank' className='btn btn-success ms-3'>Descarcar</a>
                          <button type="button" onClick={() => eliminarAdjunto(adjunto.id)} className='btn btn-danger ms-3'>Eliminar</button>
                        </li>
                      ))
                    }
                    </ul>
                  </div>
  
                  {
                    esNuevo ? (
                      <>
                      {(authInformation.rol === "Supervisor" || authInformation.es_supervisor) && (
                      <>
                      <button disabled={saving} className="btn btn-success text-dark mt-3 me-3" onClick={() => guardarNotificacion(true)} type="button">
                        {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
                        <span role="status">Enviar notificación</span>
                      </button>
                      </>
                      )}
  
                      <button disabled={saving} className="btn btn-warning text-dark mt-3" onClick={() => guardarNotificacion(false)} type="button">
                        {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
                        <span role="status">Guardar en borradores</span>
                      </button>
                      </>
                    ) : (
                    <>
                      <button disabled={saving} className="btn btn-primary mt-3" onClick={() => guardarNotificacion(false)} type="button">
                        {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
                        <span role="status">Actualizar</span>
                      </button>
                    </>
                    )
                  }
  
              </form>
              )
            }

          </div>
        </div>

      )}
      {/* <AlertaModal alerta={notificacionElegida} /> */}
    </div>
  );
};

export default NotificacionFormPartial;